import axios from 'axios';

const _ = require('lodash');
const socketio = require('socket.io-client');
const logger = require('@gral/log');
const act = require('../actions/actServer');
const actStore = require('../actions/actStore');
const actView = require('../actions/actView');
const exceptions = require('@gral/exceptions');
const App = require('@gral/app');
const log = logger('SERVER');
const Sentry = require('@sentry/browser');

const request = (url, method, data, meta, token) => {
  let msg = null;
  Promise.resolve()
    .then(() => {
      msg = { url, method, data, meta, token };

      return _ajaxPostJson(url, msg);
    })
    .then(
      response => {
        return handleResponse(method, response, () => request(url, method, data, meta, token), meta, data);
      },
      response => {
        return handleResponse(method, response, () => request(url, method, data, meta, token), meta, data);
      }
    );
};

const multipartRequest = (url, method, data, meta, token, file) => {
  let msg = null;
  Promise.resolve()
    .then(() => {
      msg = { url, method, data, meta, token };
      return _ajaxPostMultipart(url, msg, file);
    })
    .then(
      response => {
        return handleResponse(method, response, () => multipartRequest(url, method, data, meta, token, file));
      },
      response => {
        return handleResponse(method, response, () => multipartRequest(url, method, data, meta, token, file));
      }
    );
};

const handleResponse = async (method, response, callback, meta, payload) => {
  try {
    if (response?.result === 'success') {
      return act[`${method}Success`](response);
    }

    if (response.result === 'error' || response.name === 'AxiosError') {
      await checkErrorRequest(callback, response, method, meta, payload);
      return;
    }

    return act[`${method}Error`](response);
  } catch (e) {
    await checkErrorRequest(callback, response, method, meta, payload);
    return;
  }
};

const requestRaw = (url, msg) =>
  _ajaxPostJson(url, {
    ...msg,
    meta: {
      organizationId: App.cxStore.getOrganizationId(),
      roleId: App.cxStore.getRoleId(),
    },
  });

const logIn = function (credentials) {
  log.info(`Logging in as ${credentials.login}...`);
  _logIn('/api/v2/logIn?client=webApp', credentials);
};

const refreshToken = async requestCallback => {
  const token = App.cxStore.getUser()?.refreshToken;

  if (token) {
    const url = '/api/v2/refreshToken';
    return Promise.resolve()
      .then(() => _ajaxPostJson(url, { refreshToken: token }))
      .then(json => {
        //handleJsonErrors(json);
        return json;
      })
      .then(async newTokens => {
        await act.refreshTokenSuccess(newTokens);

        await requestCallback();
        return true;
      })
      .catch(async exception => {
        await App.cxStore._errorRenewToken();
        setTimeout(() => {
          act.refreshTokenError(exception);
        }, 1000);
      });
  }
};

/* const handleJsonErrors = json => {
  if (json.errors) {
    throw _serverErrorsToException(json.errors);
  }
}; */

const handleException = exception => {
  if (exception instanceof SyntaxError) {
    act.serverError();
    return true;
  }
};

const _logIn = function (url, credentials) {
  Promise.resolve()
    .then(() => _ajaxPostJson(url, credentials))
    .then(
      response => {
        act.loginSuccess(response);
        return true;
      },
      response => {
        return handleResponse('login', response, () => _logIn(url, credentials));
      }
    );
};

/* const getSettings = function (badge, token) {
  let url = '/api/getSettings';
  const meta = { organizationId: badge.organizationId, roleId: badge.roleId };
  let msg = { url, method: 'fetch', data: badge, meta, token };
  let settings = null;
  Promise.resolve()
    .then(() => _ajaxPostJson(url, msg))
    .then(json => {
      //handleJsonErrors(json);
      settings = json;
      url = '/api/userAcls';
      msg = { url, method: 'fetch', data: badge, meta, token };
      return msg;
    })
    .then(() => _ajaxPostJson(url, msg))
    .then(json => {
      //handleJsonErrors(json);
      return json;
    })
    .then(userAcls => {
      act.getSettingsSuccess({
        settings: settings.data,
        userAcls: userAcls.data,
      });
      return true;
    })
    .catch(exception => {
      act.loginError(exception);
      return false;
    });
}; */

const passwordRecovery = function (credentials) {
  log.info(`Recovering ${credentials.login} password...`);
  Promise.resolve()
    .then(() => _ajaxPostJson('/api/passwordRecovery', credentials))
    .then(json => {
      //handleJsonErrors(json);
      return act.passwordRecoverySuccess(json);
    })
    .catch(exception => {
      if (handleException(exception)) return;
      return act.passwordRecoveryError(exception);
    });
};

const passwordReset = function (credentials) {
  log.info('Resetting user password...');
  Promise.resolve()
    .then(() => _ajaxPostJson('/api/passwordReset', credentials))
    .then(json => act.passwordResetSuccess(json))
    .catch(e => {
      if (e) {
        act.passwordResetError(e);
        throw _serverErrorsToException(e.errors);
      }
      return act.passwordResetSuccess(e);
    });
};

/* const logOut = function () {
  log.info('Logging out...');
  return _socketDestroy();
}; */

// -========================================================
// ## AJAX
// -========================================================

const checkErrorRequest = async (callback, error, method, meta, payload) => {
  const errorResponse = error?.response;

  if (error) {
    const errorBackend = errorResponse?.data;
    if (errorResponse?.status === 404 || errorResponse?.status === 400) {
      if (typeof errorBackend === 'object') {
        actStore.notify({
          msg: errorBackend.error.message,
        });
      } else {
        actStore.notify({
          msg: errorBackend,
        });
      }
      return act[`${error.method || method}Error`]({ ...meta, ...error });
    }

    if (errorResponse?.status === 401) {
      if (typeof errorBackend === 'object') {
        if (errorBackend.error?.code === 'SESSION_EXPIRED') {
          return await refreshToken(callback);
        } else if (errorBackend.error?.code === 'INVALID_TOKEN' || errorBackend.error?.code === 'MISSING_AUTHENTICATION') {
          await App.cxStore._errorRenewToken();

          window.location.pathname = '/login';
          return;
        }
      } else {
        if (errorBackend?.errors?._gral) {
          return act[`${error.method}Error`](error);
        }

        return await refreshToken(callback);
      }
    } else {
      // 500
      if (error.errors?.message || error.errors?._gral) {
        actStore.notify({
          msg: error.errors?._gral?.message ?? error.errors?.error ?? error.errors?._gral,
        });

        return act[`${error.method}Error`](error);
      }

      const newError = Error('Error Server');
      Sentry.captureException(newError, {
        level: 'error',
        tags: {
          section: 'Server',
        },
        extra: {
          error: error,
          method: method,
          meta: meta,
          payload: payload,
          payloadJSON: JSON.stringify(payload),
          storage: App.cxStore.getUser(),
        },
      });
      act.checkTokenError(error);
    }
  }
};
const _ajaxPostJson = async (url, data) => {
  const response = await axios.post(url, data, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${App.cxStore.getToken()}`,
    },
  });

  return response.data;
};

const _ajaxPostMultipart = async (url, msg, file) => {
  const formData = new FormData();

  // Add msg fields to formData
  for (let key in msg) {
    // Only stringyfy objects
    if (typeof msg[key] === 'object') {
      formData.set(key, JSON.stringify(msg[key]));
    } else {
      formData.set(key, msg[key]);
    }
  }

  formData.set('file', file);

  try {
    const response = await axios.post(url, formData, {
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${App.cxStore.getToken()}`,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(`Failed to upload file: ${error.response.status} ${error.response.statusText}`);
  }
};

// -========================================================
// ## Real-time sockets (socket.io)
// -========================================================
let _socket = null;
const _notifSubscribers = {};

/* const _socketCreate = function _socketCreate() {
  log.debug('Creating socket...');
  const promise = new Promise((resolve, reject) => {
    // # _socket = socketio.connect '', {query: "token=#{token}", forceNew: true}
    _socket = socketio.connect('', { forceNew: true, transports: ['polling'] });
    _socket.once('connect', resolve);
    _socket.once('error', reject);
  });

  // Log socket.io connection-related events
  _.each(['connect', 'error', 'disconnect', 'reconnect'], evType =>
    _socket.on(evType, (...args) => log.info(`Received socket.io ${evType.toUpperCase()}`, args))
  );

  // Receive notifications
  _socket.on('notif', _socketRxNotif);

  return promise;
};
 */
/* const _socketDestroy = function _socketDestroy() {
  log.debug('Destroying socket...');
  if (_socket) {
    _socket.disconnect();
  }
  _socket = null;
};
 */
/* const _socketRxNotif = function _socketRxNotif(msg) {
  const { streamId } = msg;
  const subscribers = _notifSubscribers[streamId];
  if (!subscribers) {
    return;
  }
  return subscribers.map(subscriber => subscriber(msg));
};
 */
const socketSubscribe = function socketSubscribe(req, subscriber, onReconnect) {
  if (onReconnect && _socket) _socket.on('reconnect', onReconnect);
  return new Promise((resolve, _reject) =>
    _socket.emit('subscribe', req, streamIds => {
      for (const streamId of streamIds) {
        if (_notifSubscribers[streamId] == null) {
          _notifSubscribers[streamId] = [];
        }
        _notifSubscribers[streamId].push(subscriber);
      }
      return resolve(streamIds);
    })
  );
};

const socketUnsubscribe = function socketUnsubscribe(req, streamIds, subscriber) {
  for (const streamId of _.flatten([streamIds])) {
    const subscribers = _notifSubscribers[streamId];
    if (!subscribers) {
      continue;
    }
    _notifSubscribers[streamId] = _.filter(subscribers, o => o.name !== subscriber.name);
    if (_notifSubscribers[streamId].length === 0) {
      req.streamId = streamId;
      _socket.emit('unsubscribe', req);
      delete _notifSubscribers[streamId];
    }
  }
};

// -========================================================
// ## Helpers
// -========================================================
/* const _serverErrorsToException = function _serverErrorsToException(serverErrors) {
  if (serverErrors?._gral) {
    return new exceptions.ServerGralError(serverErrors._gral);
  }
  return new exceptions.ServerInvalidError(serverErrors);
}; */

const server = {
  request,
  requestRaw,
  multipartRequest,
  logIn,
  refreshToken,
  passwordRecovery,
  passwordReset,
  socketSubscribe,
  socketUnsubscribe,
};

export default server;

// Finally, create an instance of class `ServerIo`
